import { KeysToCamelCase, Cycle } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { SectionAtomMap } from '@/types/section';
import { getAtomForSection } from '@/utils/atoms/section';
import { objSnakeToCamel } from '@/utils/queries';
import { rawCyclesAtom } from '../queries/cycles';
import { playerCyclesAtom } from '../queries/players';
import { teamCyclesAtom } from '../queries/teams';

const cycleSectionAtom = atom<SectionAtomMap<KeysToCamelCase<Cycle>[]>>(() => ({
  player: atom(async get => (await get(playerCyclesAtom)).map(({ cycle }) => cycle)),
  dataLocker: atom(async get => (await get(rawCyclesAtom)).data.map(objSnakeToCamel)),
  team: atom(async get => (await get(teamCyclesAtom)).map(({ cycle }) => cycle)),
  // The following section currently does not have cycles associated with them, so we return an empty array
  // Add to this if we need the available cycles for these sections in the future
  game: atom(() => Promise.resolve([])),
}));

export const cyclesForSectionAtom = atom(getAtomForSection(cycleSectionAtom));
